import { useEffect, useMemo } from "react";
import { useGlobalContext } from "../context/GlobalComponentsContext";
import { useGetFamilyMembersQuery } from "src/queries/gqlTypes";
import { AccountType } from "../model/userModels";
import { reportError } from "../utils/errorUtils";

export default function useFamilyMembers() {
  const { data, loading, error } = useGetFamilyMembersQuery();
  const { showError } = useGlobalContext();

  useEffect(() => {
    if (error) {
      reportError(error);
      showError();
    }
  }, [error, showError]);

  const familyMembers = useMemo(() => data?.familyMembers || [], [data]);

  const userAndChildren = useMemo(() => {
    return data?.familyMembers?.filter(fm => fm.id === data?.me?.id || fm.accountType === AccountType.CHILD) || [];
  }, [data]);

  return { familyMembers, userAndChildren, loading };
}
